import { render, staticRenderFns } from "./CourseEditModal.vue?vue&type=template&id=476b8ccc&"
import script from "./CourseEditModal.vue?vue&type=script&lang=js&"
export * from "./CourseEditModal.vue?vue&type=script&lang=js&"
import style0 from "./CourseEditModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports